"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.description.placeholder': '输入知识描述',
};
